import React from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PageContainer, Hero } from '../../components';

import './CookiesPage.scss';

function CookiesPage() {
  const { t } = useTranslation();

  return (
    <div className='main-content'>
      <Hero>
        <h1>{t('COOKIES_POLICY_TITLE')}</h1>
      </Hero>
      <PageContainer>
        <Row>
          <p>{t('COOKIES_POLICY_INTRO')}</p>
          <h4>{t('NECESSARY_COOKIES_TITLE')}</h4>
          <p>{t('NECESSARY_COOKIES_TEXT')}</p>
          <h4>{t('MARKETING_COOKIES_TITLE')}</h4>
          <p>{t('MARKETING_COOKIES_TEXT')}</p>
          <h4>{t('YOUR_COOKIES_CHOICES_TITLE')}</h4>
          <p>{t('YOUR_COOKIES_CHOICES_TEXT')}</p>
          <h4>{t('MANAGE_COOKIES_TITLE')}</h4>
          <p>{t('MANAGE_COOKIES_TEXT')}</p>
          <h4>{t('CONTACT_COOKIES_TITLE')}</h4>
          <p>{t('CONTACT_COOKIES_TEXT')}</p>
        </Row>
      </PageContainer>
    </div>
  );
}

export default CookiesPage;